@if (this.product$ | async; as product) {
  <div
    class="tab-pane fade flex-even active show"
    id="insuranceDocuments"
    role="tabpanel"
    aria-labelledby="insuranceDocuments-tab"
    >
    @if (product.productCoverages.length != 0) {
      <div
        class="d-flex flex-column h-100"
        >
        <div class="row mt-2">
          <table class="table table-striped border-bottom">
            <thead>
              <tr>
                <th>
                  <a translate>PRODUCT_LBL_VALUE</a>
                </th>
              </tr>
            </thead>
            <tbody>
              @for (coverage of product.productCoverages; track coverage) {
                <tr
                  class="row-action"
                  >
                  <td>{{ coverage.value }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }
  </div>
}
